import { formatMoney, formatPercent, toNumber } from '@blimo/shared';
import { cn } from '../lib/utils.js';

/**
 * Change value with explicit sign („+1.200,00 €“ / „-300,00 €“) – colour is a second channel only:
 * increase = success, decrease = destructive.
 * @param {{ value: number|string|null|undefined, percent?: boolean, className?: string }} props
 */
export function DeltaText({ value, percent = false, className }) {
  const n = toNumber(value);
  const text = percent ? formatPercent(n, { sign: true }) : formatMoney(n, { sign: true });
  return (
    <span className={cn('numeric', n !== null && n > 0 && 'text-success-subtle-foreground', n !== null && n < 0 && 'text-destructive', className)}>{text}</span>
  );
}

/**
 * Open-item amount in display sign (API: negative = arrears/Forderung → red, positive = credit).
 * The sign is always shown so that colour is not the only channel.
 * @param {{ value: number|string|null|undefined, className?: string }} props
 */
export function OpenItemAmount({ value, className }) {
  const n = toNumber(value);
  return <span className={cn('numeric', n !== null && n < 0 && 'font-medium text-destructive', className)}>{formatMoney(n, { sign: true })}</span>;
}
